import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { setStoredValue } from "../../src/_helpers/storageHelper";

// create slice

const name = "kioskLogin";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    createExtraReducers(builder, extraActions);
  },
});

// exports

export const kioskLoginActions = { ...slice.actions, ...extraActions };
export const kioskLoginReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    loginDetails: {},
    facilityDetails: [],
    podDetails: [],
    kioskDetails: [],
    verificationCodeValidate: [],
    loginResponse: null,
    SecurityQuestions: [],
    SQInsertUpdateResponse: null,
    ValidateSecurityQuestions: [],
    KiosksActiveStatusResponse: [],
    KioskRestrictIntervalValidateResponse: [],
    applicationSettingsData: {},
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;


  return {
    getKiosksMacAddressValidate: getKiosksMacAddressValidate(),
    getUpdateKiosksActiveStatus: getUpdateKiosksActiveStatus(),
    getfacilityDetails: getfacilityDetails(),
    getLoadPodDropDown: getLoadPodDropDown(),
    getLoadKioskDropDown: getLoadKioskDropDown(),
    getKiosksVerificationCodeValidate: getKiosksVerificationCodeValidate(),
    getInmateLoginValidate: getInmateLoginValidate(),
    getLoadSecurityQuestionSet: getLoadSecurityQuestionSet(),
    inmateSecurityQuestionInsertUpdate: inmateSecurityQuestionInsertUpdate(),
    getLoadInmateValidateSecurity: getLoadInmateValidateSecurity(),
    getKioskRestrictIntervalValidate: GetKioskRestrictIntervalValidate(),
    MaintenanceMode: MaintenanceMode(),
    PostEloDeviceDetails: PostEloDeviceDetails(),
  };

  function MaintenanceMode() {
    return createAsyncThunk(`${name}/MaintenanceMode`, async (AppName) => {
      return await fetchWrapper.get(
        `${baseUrl}/Common/GetApplicationSettings?appName=${AppName}`
      );
    });
  }

  function GetKioskRestrictIntervalValidate() {
    return createAsyncThunk(
      `${name}/GetKioskRestrictIntervalValidate`,
      async ({ facilityID, kioskCode, InmateResidentId }) => {
        if (InmateResidentId) {
          return await fetchWrapper.post(
            `${baseUrl}/Kiosk/KioskLogin/GetKioskRestrictIntervalValidatewithPod?facilityID=${facilityID}&kioskCode=${kioskCode}&InmateResidentId=${InmateResidentId}`
          );
        } else {
          return await fetchWrapper.post(
            `${baseUrl}/Kiosk/KioskLogin/GetKioskRestrictIntervalValidate?facilityID=${facilityID}&kioskCode=${kioskCode}`
          );
        }
      }
    );
  }

  function getfacilityDetails() {
    return createAsyncThunk(
      `${name}/getfacilityDetails`,
      async () => await fetchWrapper.get(`${baseUrl}/Common/LoadFacilityDropDown?ActiveStatus=1`)
    );
  }
  function getLoadPodDropDown() {
    return createAsyncThunk(
      `${name}/getLoadPodDropDown`,
      async (selectedFacility) => await fetchWrapper.get(`${baseUrl}/Common/LoadPodDropDown?facilityID=${selectedFacility}&SharedPod=2&ActiveStatus=1`)
    );
  }
  function getLoadKioskDropDown() {
    return createAsyncThunk(
      `${name}/getLoadKioskDropDown`,
      async ({ selectedPod, selectedFacility }) =>
        await fetchWrapper.get(`${baseUrl}/Kiosk/KioskLogin/LoadKiosksInactive?facilityID=${selectedFacility}&podID=${selectedPod}`)
    );
  }
  function getKiosksVerificationCodeValidate() {
    return createAsyncThunk(
      `${name}/getKiosksVerificationCodeValidate`,
      async ({ selectedFacility, selectedPod, selectedKiosk, verificationCode }) =>
        await fetchWrapper.post(`${baseUrl}/kiosk/KioskLogin/GetKiosksVerificationCodeValidate?facilityID=${selectedFacility}&podID=${selectedPod}&kiosksID=${selectedKiosk}&kiosksVerificationCode=${verificationCode}`)
    );
  }
  function getKiosksMacAddressValidate() {
    return createAsyncThunk(
      `${name}/getKiosksMacAddressValidate`,
      async (macId) => await fetchWrapper.get(`${baseUrl}/kiosk/KioskLogin/GetKiosksMacAddressValidate?KiosksMacAddress=${macId}`)
    );
  }
  function getUpdateKiosksActiveStatus() {
    return createAsyncThunk(
      `${name}/getUpdateKiosksActiveStatus`,
      async ({ selectedKiosk, selectedFacility, verificationCode }) => await fetchWrapper.get(`${baseUrl}/kiosk/KioskLogin/GetUpdateKiosksActiveStatus?kiosksID=${selectedKiosk}&facilityID=${selectedFacility}&kiosksMacAddress=${verificationCode}`)
    );
  }

  function getInmateLoginValidate() {
    return createAsyncThunk(
      `${name}/getInmateLoginValidate`,
      async (loginPayload) => await fetchWrapper.get(
        `${baseUrl}/kiosk/KioskLogin/GetInmateLoginValidate?InmateResidentId=${loginPayload.InmateResidentId}&UserPassword=${loginPayload.UserPassword}&FacilityID=${loginPayload.facilityID}&KiosksCode=${loginPayload.kiosksCode}&IsApplogin=${loginPayload.IsApplogin}`)
    );
  }
  function getLoadSecurityQuestionSet() {
    return createAsyncThunk(
      `${name}/getLoadSecurityQuestionSet`,
      async (loginResponse) => await fetchWrapper.get(`${baseUrl}/kiosk/KioskLogin/LoadSecurityQuestionSet?facilityID=${loginResponse?.facilityID}&inmateId=${loginResponse?.InmateID}`)
    );
  }
  function inmateSecurityQuestionInsertUpdate() {
    return createAsyncThunk(
      `${name}/inmateSecurityQuestionInsertUpdate`,
      async (objData) => await fetchWrapper.post(`${baseUrl}/kiosk/KioskLogin/inmateSecurityQuestionInsertUpdate`, objData)
    );
  }
  function getLoadInmateValidateSecurity() {
    return createAsyncThunk(
      `${name}/LoadInmateValidateSecurity`,
      async (loginResponse) => await fetchWrapper.get(`${baseUrl}/kiosk/KioskLogin/LoadInmateValidateSecurity?facilityID=${loginResponse?.facilityID}&inmateId=${loginResponse?.InmateID}`)
    );
  }
  function PostEloDeviceDetails() {
    return createAsyncThunk(
      `${name}/InsertInmateDeviceLoginDetails`,
      async (DeviceDetPayload) => await fetchWrapper.post(
        `${baseUrl}/kiosk/KioskLogin/InsertInmateDeviceLoginDetails`, DeviceDetPayload)
    );
  }
}



function createExtraReducers(builder, actions) {
  builder
    .addCase(actions.getKioskRestrictIntervalValidate.pending, (state) => {
      state.KioskRestrictIntervalValidateResponse = { loading: true };
    })
    .addCase(actions.getKioskRestrictIntervalValidate.fulfilled, (state, action) => {
      state.KioskRestrictIntervalValidateResponse = action.payload;
      setStoredValue("KioskRestrictIntervalValidate", action.payload, true);
    })
    .addCase(actions.getKioskRestrictIntervalValidate.rejected, (state, action) => {
      state.KioskRestrictIntervalValidateResponse = { error: action.error };
    })
    .addCase(actions.getKiosksMacAddressValidate.pending, (state) => {
      state.loginDetails = { loading: true };
    })
    .addCase(actions.getKiosksMacAddressValidate.fulfilled, (state, action) => {
      state.loginDetails = action.payload;
      setStoredValue("loginDetails", action.payload, true);
    })
    .addCase(actions.getKiosksMacAddressValidate.rejected, (state, action) => {
      state.loginDetails = { error: action.error };
    })
    .addCase(actions.getfacilityDetails.pending, (state) => {
      state.facilityDetails = [];
    })
    .addCase(actions.getfacilityDetails.fulfilled, (state, action) => {
      state.facilityDetails = action.payload;
    })
    .addCase(actions.getfacilityDetails.rejected, (state, action) => {
      state.facilityDetails = { error: action.error };
    })
    .addCase(actions.getLoadPodDropDown.pending, (state) => {
      state.podDetails = [];
    })
    .addCase(actions.getLoadPodDropDown.fulfilled, (state, action) => {
      state.podDetails = action.payload;
    })
    .addCase(actions.getLoadPodDropDown.rejected, (state, action) => {
      state.podDetails = { error: action.error };
    })
    .addCase(actions.getLoadKioskDropDown.pending, (state) => {
      state.kioskDetails = [];
    })
    .addCase(actions.getLoadKioskDropDown.fulfilled, (state, action) => {
      state.kioskDetails = action.payload;
    })
    .addCase(actions.getLoadKioskDropDown.rejected, (state, action) => {
      state.kioskDetails = { error: action.error };
    })
    .addCase(actions.getKiosksVerificationCodeValidate.pending, (state) => {
      state.verificationCodeValidate = { loading: true };
    })
    .addCase(actions.getKiosksVerificationCodeValidate.fulfilled, (state, action) => {
      state.verificationCodeValidate = action.payload;
    })
    .addCase(actions.getKiosksVerificationCodeValidate.rejected, (state, action) => {
      state.verificationCodeValidate = { error: action.error };
    })
    .addCase(actions.getInmateLoginValidate.pending, (state) => {
      state.loginResponse = { loading: true };
    })
    .addCase(actions.getInmateLoginValidate.fulfilled, (state, action) => {
      state.loginResponse = action.payload;
      if (action?.meta?.arg?.InmateResidentId == "00" && action?.meta?.arg?.UserPassword == "00") {
        action.KioskRestrictIntervalValidateResponse = action.payload?.RestrictIntervals;
        setStoredValue("KioskRestrictIntervalValidate", action.payload?.RestrictIntervals[0], true);
      }
      else {
        setStoredValue("loginResponse", action.payload, true);
      }
    })
    .addCase(actions.getInmateLoginValidate.rejected, (state, action) => {
      state.loginResponse = { error: action.error };
    })
    .addCase(actions.getLoadSecurityQuestionSet.pending, (state) => {
      state.SecurityQuestions = [];
    })
    .addCase(actions.getLoadSecurityQuestionSet.fulfilled, (state, action) => {
      state.SecurityQuestions = action.payload;
    })
    .addCase(actions.getLoadSecurityQuestionSet.rejected, (state, action) => {
      state.SecurityQuestions = { error: action.error };
    })
    .addCase(actions.inmateSecurityQuestionInsertUpdate.pending, (state) => {
      state.SQInsertUpdateResponse = { loading: true };
    })
    .addCase(actions.inmateSecurityQuestionInsertUpdate.fulfilled, (state, action) => {
      state.SQInsertUpdateResponse = action.payload;
    })
    .addCase(actions.inmateSecurityQuestionInsertUpdate.rejected, (state, action) => {
      state.SQInsertUpdateResponse = { error: action.error };
    })
    .addCase(actions.getLoadInmateValidateSecurity.pending, (state) => {
      state.ValidateSecurityQuestions = [];
    })
    .addCase(actions.getLoadInmateValidateSecurity.fulfilled, (state, action) => {
      state.ValidateSecurityQuestions = action.payload;
    })
    .addCase(actions.getLoadInmateValidateSecurity.rejected, (state, action) => {
      state.ValidateSecurityQuestions = { error: action.error };
    })
    .addCase(actions.getUpdateKiosksActiveStatus.pending, (state) => {
      state.KiosksActiveStatusResponse = [];
    })
    .addCase(actions.getUpdateKiosksActiveStatus.fulfilled, (state, action) => {
      state.KiosksActiveStatusResponse = action.payload;
    })
    .addCase(actions.getUpdateKiosksActiveStatus.rejected, (state, action) => {
      state.KiosksActiveStatusResponse = { error: action.error };
    })
    //maintenance mode
    .addCase(extraActions.MaintenanceMode.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.MaintenanceMode.fulfilled, (state, action) => {
      state.applicationSettingsData = action.payload;
      state.error = null;
    })
    .addCase(extraActions.MaintenanceMode.rejected, (state, action) => {
      state.error = action.error;
    });
}
